import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const runSupportV2Trueup = {
  name: "runSupportV2Trueup" as const,
  input: z
    .object({
      teamId: zExt.objectId(),
      dryRun: z.boolean(),
      matchVoice: z.boolean().optional(),
      noMigrateMissing: z.boolean().optional(),
      limit: z.number().int().positive().optional(),
    })
    .strict(),
  output: z.object({ workflowId: z.string() }),
};
